<template>
  <div>
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <feather-icon icon="GlobeIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" />

      <vs-dropdown-menu>
        <vs-dropdown-item v-for="(lang, index) in languages" :key="index" @click="onLocaleChange(lang.code)">
          {{ lang.name }}
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { LanguageEnum } from "@/enums";

export default {
  name: "locale-dropdown",
  computed: {
    languages() {
      return LanguageEnum;
    },
  },
  components: {
    "v-select": vSelect,
  },
  methods: {
    onLocaleChange(locale) {
      if (locale) {
        this.$i18n.locale = locale;
        localStorage.setItem("locale", this.$i18n.locale);
        this.$store.commit("CHANGE_LOCALE", {
          locale: this.$i18n.locale,
        });
      }
    },
  },
};
</script>
